import React, { useContext } from "react"
import styled, { ThemeContext } from "styled-components"
import { layout } from "styled-system"
import {
  AttentionSeeker,
  Bounce,
  Fade,
  Flip,
  Hinge,
  JackInTheBox,
  Roll,
  Rotate,
  Slide,
  Zoom,
} from "react-awesome-reveal"
import { fadeInUpKeyframes } from "../../lib/styled-system/reveal-keyframes"

const RevealWrapper = styled.div`
  ${layout}

  & div.react-awesome-reveal {
    animation-timing-function: ${props =>
      props.animationTimingFunction || "ease"};
    height: 100%;
  }
`

const ANIMATION_COMPONENT_OPTIONS = {
  AttentionSeeker,
  Bounce,
  Fade,
  Flip,
  Hinge,
  JackInTheBox,
  Roll,
  Rotate,
  Slide,
  Zoom,
}

/*
 * Uses the reveal effect defined in the theme
 */

const Reveal = ({ children, height, width, ...rest }) => {
  // Get reveal effect and durations from theme
  const { reveal, durations } = useContext(ThemeContext)
  const revealEffect = reveal?.effect || "none"
  const revealDuration = durations[reveal?.duration] || durations["md"]
  const revealTimingFunction = reveal?.timingFunction || "ease"

  let animationType = revealEffect?.[0].toUpperCase() + revealEffect.slice(1)
  let direction = "up"

  if (animationType.includes("-")) {
    const [effect, dir] = animationType.split("-")
    animationType = effect
    direction = dir
  }
  const AnimationComponent = ANIMATION_COMPONENT_OPTIONS[animationType] || Fade // reveal animition default Fade when effect is not specify

  return (
    <RevealWrapper
      animationTimingFunction={revealTimingFunction}
      height={height}
      width={width}
    >
      <AnimationComponent
        className="react-awesome-reveal"
        direction={direction} // Usually "down", "left", "right" or "up", with some exceptions documented in the code
        triggerOnce // Ensures animation triggers only once
        duration={revealDuration}
        delay={0} // in milli seconds
        fraction="0" //number between 0 and 1, with 0 meaning that the animation starts as soon as the component intersects the vieport and then ends
        // cascade={true} //Boolean prop to stagger the animation (see Staggered Animations).
        // AttentionSeeker take in an effect props with the following options// "bounce" // "flash" // "headShake" // "heartBeat" // "jello" // "pulse" // "rubberBand" // "shake" // "shakeX" // "shakeY" // "swing" // "tada" // "wobble"
        // damping={0.5} //Factor that affects the delay that each animated component in a cascade animation will be assigned.

        keyframes={
          (animationType === "Fade" && direction === "up") ||
          revealEffect === "none"
            ? fadeInUpKeyframes
            : undefined
        }
        {...rest}
      >
        {children}
      </AnimationComponent>
    </RevealWrapper>
  )
}

export default Reveal
